module.exports = __webpack_public_path__ + "img/stop_btn.88af7c42.png";